import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FieldTypeConfig } from "@ngx-formly/core";
import { FieldType } from "@ngx-formly/material/form-field";

@Component({
  selector: "lib-formly-intl-phone-input-type",
  standalone: false,
  templateUrl: "./formly-intl-phone-input-type.component.html",
  styleUrls: ["./formly-intl-phone-input-type.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyIntlPhoneInputTypeComponent extends FieldType<FieldTypeConfig> {
  constructor() {
    super();
  }
}
